<template>
  <div class="flex min-h-screen w-full flex-col justify-between text-gray-800">
    <NavigationMain v-if="filteredNavigations?.main" :nav="filteredNavigations.main" :meta="filteredNavigations.mainmeta" />

    <main class="flex-1">
      <slot />
    </main>

  <NavigationFooter
      v-if="filteredNavigations?.footer"
      :nav="filteredNavigations.footer"
      :globals="filteredNavigations.globals"
      :meta="filteredNavigations.footermeta"
  />
  </div>
</template>

<script setup>
import { store } from '/store.js'

function filterPublished(tree) {
  if (!tree) return []
  return tree
    .filter((node) => !node.page.status || node.page.status === 'published')
    .map((node) => ({
      ...node,
      children: filterPublished(node.children),
    }))
}

function filterNavPublished(nav) {
  if (!nav) return nav
  return { ...nav, tree: filterPublished(nav.tree) }
}

// Fetch all navigations and globals
const { data: navigations } = await useCmsGql({
  operation: 'Navigations',
})

const filteredNavigations = computed(() => {
  if (!navigations.value) return null
  return {
    ...navigations.value,
    main: filterNavPublished(navigations.value.main),
    footer: filterNavPublished(navigations.value.footer),
    mainmeta: filterNavPublished(navigations.value.mainmeta),
    footermeta: filterNavPublished(navigations.value.footermeta),
  }
})

if (navigations.value && navigations.value.globals) {
  // populate the store with globals
  store.globals = navigations.value?.globals
  // populate the store with the main nav for the breadcrumbs
  store.navigations = { main: filterNavPublished(navigations?.value?.main) }
}
</script>
